module.exports = function() {
  return new Worker(__webpack_public_path__ + "fc039fcde70306c842a8.worker.js");
};